import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = {
  key: 0,
  class: "p-field"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Send to:", -1)
const _hoisted_4 = { class: "p-field-radiobutton" }
const _hoisted_5 = { for: "recipient_drivers_working" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Only drivers working")
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "p-field-radiobutton" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "recipient_brokers" }, "Send to Brokers", -1)
const _hoisted_10 = {
  key: 0,
  class: "p-field-radiobutton"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "recipient_all" }, "Send to all broker drivers", -1)
const _hoisted_12 = { class: "p-field" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "message" }, "Title", -1)
const _hoisted_14 = { class: "p-field" }
const _hoisted_15 = { for: "message" }
const _hoisted_16 = { class: "p-field" }
const _hoisted_17 = { class: "p-field-checkbox" }
const _hoisted_18 = { for: "sms" }
const _hoisted_19 = { class: "p-field-checkbox" }
const _hoisted_20 = { for: "email" }
const _hoisted_21 = { class: "p-field-checkbox" }
const _hoisted_22 = { for: "push" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showRecipientOptions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_RadioButton, {
              id: "recipient_drivers_working",
              name: "recipientType",
              value: "drivers_working",
              modelValue: _ctx.recipientType,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.recipientType = $event)),
              disabled: !_ctx.hasAssignedDrivers
            }, null, 8, ["modelValue", "disabled"]),
            _createElementVNode("label", _hoisted_5, [
              _hoisted_6,
              (!_ctx.hasAssignedDrivers)
                ? (_openBlock(), _createElementBlock("small", _hoisted_7, " (no drivers assigned yet)"))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_RadioButton, {
              id: "recipient_brokers",
              name: "recipientType",
              value: "brokers",
              modelValue: _ctx.recipientType,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.recipientType = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_9
          ]),
          (!_ctx.disableSendAllBrokerDriver)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_RadioButton, {
                  id: "recipient_all",
                  name: "recipientType",
                  value: "all",
                  modelValue: _ctx.recipientType,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.recipientType = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_11
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createVNode(_component_InputText, {
        id: "subject",
        modelValue: _ctx.subject,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.subject = $event)),
        disabled: _ctx.disabled
      }, null, 8, ["modelValue", "disabled"])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.messageLabel), 1),
      _createVNode(_component_Textarea, {
        id: "message",
        modelValue: _ctx.text,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.text = $event)),
        disabled: _ctx.disabled
      }, null, 8, ["modelValue", "disabled"])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_Checkbox, {
          id: "sms",
          modelValue: _ctx.sendSms,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.sendSms = $event)),
          binary: true,
          disabled: _ctx.disabled
        }, null, 8, ["modelValue", "disabled"]),
        _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('message.sms')), 1)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_Checkbox, {
          id: "email",
          modelValue: _ctx.sendEmail,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.sendEmail = $event)),
          binary: true,
          disabled: _ctx.disabled
        }, null, 8, ["modelValue", "disabled"]),
        _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('message.email')), 1)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_Checkbox, {
          id: "push",
          modelValue: _ctx.sendPush,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.sendPush = $event)),
          binary: true,
          disabled: _ctx.disabled
        }, null, 8, ["modelValue", "disabled"]),
        _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('message.push')), 1)
      ])
    ])
  ]))
}